// Toplu profil fotoğrafı yüklemenin saf mantığı (bileşenden ayrı — birim testli).

// Tarayıcıdan depoya tek dosya sınırı. Sunucu dosya içeriğini görmez; büyük fotoğraf profil kartında gereksiz yük olur.
export const MAX_PHOTO_BYTES = 5 * 1024 * 1024;
// Sunucunun bir apply çağrısında kabul ettiği en fazla öğe (EmployeePhotoDataAccess.MaxApplyItems) ve eşleme sınırı.
export const APPLY_CHUNK = 200;
export const MAX_FILES = 2000;
// Aynı anda depoya giden yükleme sayısı.
export const UPLOAD_CONCURRENCY = 4;

export const ACCEPTED_TYPES = ['image/jpeg', 'image/png', 'image/webp'];

// Sunucu eşlemesi + istemci boyut denetimi → satırlar. Sunucunun "matched" dediği ama 5 MB'yi aşan dosya "tooLarge"
// olur ve yüklenmez. Satır sırası dosya sırasıdır (sunucu da aynı sırayla döner).
export function buildRows(files, matchItems) {
  return files.map((file, i) => {
    const m = matchItems?.[i] || {};
    const status = m.status === 'matched' && file.size > MAX_PHOTO_BYTES ? 'tooLarge' : (m.status || 'invalidFile');
    return {
      key: `${i}-${file.name}`,
      file,
      fileName: file.name,
      status,
      employeeId: m.employeeId || null,
      fullName: m.fullName || null,
      registrationNumber: m.registrationNumber || null,
      hasPhoto: Boolean(m.hasPhoto),
    };
  });
}

export const uploadableRows = (rows) => rows.filter((r) => r.status === 'matched' && r.employeeId);

export function countByStatus(rows) {
  return rows.reduce((acc, r) => ({ ...acc, [r.status]: (acc[r.status] || 0) + 1 }), {});
}

export function chunk(list, size) {
  const out = [];
  for (let i = 0; i < list.length; i += size) out.push(list.slice(i, i + size));
  return out;
}

// items üzerinde en fazla `limit` eşzamanlı worker(item, index) — sonuçlar item sırasıyla döner; bir öğenin hatası
// diğerlerini durdurmaz (worker kendi hatasını sonuç olarak döndürmeli).
export async function mapWithConcurrency(items, limit, worker, onProgress) {
  const results = new Array(items.length);
  let next = 0;
  let done = 0;
  const run = async () => {
    while (next < items.length) {
      const index = next;
      next += 1;
      // eslint-disable-next-line no-await-in-loop
      results[index] = await worker(items[index], index);
      done += 1;
      if (onProgress) onProgress(done);
    }
  };
  await Promise.all(Array.from({ length: Math.min(limit, items.length) }, run));
  return results;
}
